import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import { setAvailability } from '../../slices/timesheet/availabilitySlice';
import type { AvailabilityResponse } from '../../../types/availabilitySliceInterface';
import type { AvailabilityApiSliceState } from '../../../types/availabilityApiSliceInterface';
import getAuth from '../../../utils/api/getToken';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Timesheet`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) headers.set('authorization', `Bearer ${token.auth}`);
    return headers;
  },
});

export const availabilityApi = createApi({
  reducerPath: 'availabilityApi',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  tagTypes: ['Availability'],
  endpoints: (builder) => ({
    calculateAvailability: builder.query<
      AvailabilityResponse,
      AvailabilityApiSliceState
    >({
      query: (body) => ({
        url: `/calculate-availability`,
        method: 'POST',
        body,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAvailability(data));
        } catch (_err) {
          // handled by global error handler via baseQuery wrapper
        }
      },
    }),
  }),
});

export const {
  useCalculateAvailabilityQuery,
  useLazyCalculateAvailabilityQuery,
} = availabilityApi;
